export const SUPPORTED_LANGUAGES = ['tr', 'en'] as const;

export type SiteLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SiteLanguage = 'tr';

export const OG_LOCALE: Record<SiteLanguage, string> = {
  tr: 'tr_TR',
  en: 'en_US',
};
